import apiUrl from "../../Apiurl";

const HEADER_MESSAGE_BASE_PATH = "/interfaccia/header-message";

export const emptyHeaderMessage = {
  text: "",
  enabled: false,
  startsAt: "",
  expiresAt: "",
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data?.message || data?.error || `Errore API ${response.status}`,
    );
  }

  return data;
};

export const fetchActiveHeaderMessage = async (accessToken) => {
  const response = await fetch(`${apiUrl}${HEADER_MESSAGE_BASE_PATH}/active`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return parseResponse(response);
};

export const fetchHeaderMessageConfig = async (accessToken) => {
  const response = await fetch(`${apiUrl}${HEADER_MESSAGE_BASE_PATH}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return parseResponse(response);
};

export const saveHeaderMessageConfig = async (accessToken, payload) => {
  const response = await fetch(`${apiUrl}${HEADER_MESSAGE_BASE_PATH}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return parseResponse(response);
};
